var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99264 7.79779C0.00245425 8.06551 0.00245425 13.42 3.99264 13.6877H13.4332C14.5709 13.6877 15.6915 13.294 16.5235 12.5853C19.3251 10.3175 17.8309 5.78196 14.1463 5.35675C12.8219 -2.02927 1.30991 0.773947 4.02663 7.8135",
    stroke: "#2A2D34",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33561 17.7475C11.7913 17.7475 13.7821 15.7638 13.7821 13.3169C13.7821 10.8699 11.7913 8.88623 9.33561 8.88623C6.8799 8.88623 4.88916 10.8699 4.88916 13.3169C4.88916 15.7638 6.8799 17.7475 9.33561 17.7475Z",
    fill: "#00A651",
    stroke: "#2A2D34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 14.8674V12.209",
    stroke: "#2A2D34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00195 13.0953L9.33589 11.7661L10.6698 13.0953",
    stroke: "#2A2D34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadMini);
export default __webpack_public_path__ + "static/media/download_mini.5d1ba2107ac13f2e2a1d4eee474dc62a.svg";
export { ForwardRef as ReactComponent };